import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("header", { class: "w-full px-8 py-4" }, [
  /*#__PURE__*/_createVNode("h1", { class: "text-lg text-black font-bold" }, " みんがく | スクールAI管理ページ ")
], -1)
const _hoisted_2 = { class: "flex flex-col items-center container mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "text-lg text-black font-bold mb-12" }, " アカウント不具合対応ページ ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "mb-12 text-sm text-gray-500 text-center" }, [
  /*#__PURE__*/_createTextVNode(" 生徒削除のフローで不具合があった場合、ログインに失敗したり、登録に失敗したります。"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" その場合、該当のスクールを検索し、問題の発生しているログインIDを入力することで解決できることがあります。 ")
], -1)
const _hoisted_5 = { class: "flex flex-col gap-4" }
const _hoisted_6 = { class: "flex flex-col gap-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 名前で検索 ")
const _hoisted_8 = { class: "flex flex-col gap-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" スクールドキュメントIDで検索 ")
const _hoisted_10 = {
  key: 0,
  class: "mt-8 w-full max-w-2xl flex flex-col gap-4"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("h3", { class: "text-lg text-black font-bold" }, "検索結果", -1)
const _hoisted_12 = { class: "bg-primary-100 rounded-md border border-primary-100" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "grid grid-cols-2 py-2 px-4 border-b border-gray-300" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-sm font-medium text-gray-700 border-r border-gray-300 pr-4" }, " 学校名 "),
  /*#__PURE__*/_createVNode("div", { class: "text-sm font-medium text-gray-700 pl-4" }, " オーナー ")
], -1)
const _hoisted_14 = { class: "text-sm text-gray-700 border-r border-gray-300 pr-4 flex items-center" }
const _hoisted_15 = /*#__PURE__*/_createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_16 = { class: "text-sm text-gray-700 pl-4" }
const _hoisted_17 = {
  key: 0,
  class: "px-4 pb-4 bg-gray-50 border-t border-gray-200"
}
const _hoisted_18 = { class: "flex flex-col gap-3 max-w-md" }
const _hoisted_19 = { class: "pt-3" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 実行 ")
const _hoisted_21 = {
  key: 1,
  class: "mt-8 w-full max-w-2xl flex flex-col items-center"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-50 border border-gray-200 rounded-md p-8 text-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 mb-3" }, [
    /*#__PURE__*/_createVNode("svg", {
      class: "w-12 h-12 mx-auto",
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24"
    }, [
      /*#__PURE__*/_createVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("p", { class: "text-sm text-gray-500" }, " 結果がありません "),
  /*#__PURE__*/_createVNode("p", { class: "text-xs text-gray-400 mt-2" }, " 別のキーワードで検索してください ")
], -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" ホームへ ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_button = _resolveComponent("m-button")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("main", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("section", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", null, [
            _createVNode(_component_m_text_field, {
              label: "学校名で検索（前方一致で部分検索可）",
              type: "text",
              value: _ctx.name,
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event))
            }, null, 8, ["value"])
          ]),
          _createVNode("div", null, [
            _createVNode(_component_m_button, { onClick: _ctx.searchByName }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", null, [
            _createVNode(_component_m_text_field, {
              label: "スクールDocIdで検索（完全一致）",
              type: "text",
              value: _ctx.schoolDocId,
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.schoolDocId = $event))
            }, null, 8, ["value"])
          ]),
          _createVNode("div", null, [
            _createVNode(_component_m_button, { onClick: _ctx.searchByDocId }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      (_ctx.foundSchools.length)
        ? (_openBlock(), _createBlock("section", _hoisted_10, [
            _hoisted_11,
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.foundSchools, (school, i) => {
                return (_openBlock(), _createBlock("div", {
                  key: i,
                  class: "border-t border-gray-300"
                }, [
                  _createVNode("div", {
                    class: "grid grid-cols-2 py-2 px-4 transition-colors duration-300 hover:bg-white cursor-pointer",
                    onClick: ($event: any) => (_ctx.toggleExpanded(i))
                  }, [
                    _createVNode("div", _hoisted_14, [
                      _createVNode("span", null, _toDisplayString(school.data.name), 1),
                      (_openBlock(), _createBlock("svg", {
                        class: ["w-4 h-4 ml-2 transition-transform duration-200", { 'transform rotate-180': _ctx.expandedSchoolIndex === i }],
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _hoisted_15
                      ], 2))
                    ]),
                    _createVNode("div", _hoisted_16, _toDisplayString(school.ownerName ?? ""), 1)
                  ], 8, ["onClick"]),
                  (_ctx.expandedSchoolIndex === i)
                    ? (_openBlock(), _createBlock("div", _hoisted_17, [
                        _createVNode("div", _hoisted_18, [
                          _createVNode("div", _hoisted_19, [
                            _createVNode(_component_m_text_field, {
                              label: "ログインID",
                              type: "text",
                              placeholder: "問題が報告されたログインIDを入力してください",
                              value: _ctx.inputValue,
                              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.inputValue = $event))
                            }, null, 8, ["value"])
                          ]),
                          _createVNode("div", null, [
                            _createVNode(_component_m_button, {
                              color: "primary-600",
                              size: "sm",
                              onClick: ($event: any) => (_ctx.handleUndeletedUser(school, _ctx.inputValue))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_20
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showNoResultsMessage)
        ? (_openBlock(), _createBlock("section", _hoisted_21, [
            _hoisted_22
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_m_button, {
        class: "mt-24",
        onClick: _ctx.moveToHome
      }, {
        default: _withCtx(() => [
          _hoisted_23
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}